import WorkerLocationStatusIcon from './WorkerLocationStatusIcon';

const EMPTY_WORKER_IDS = new Set();

function getWorkloadCount(workerWorkloadCounts, workerId) {
    const workload = workerWorkloadCounts?.[workerId];
    if (!workload) {
        return 0;
    }

    return (workload.incompleteCleaning || 0)
        + (workload.completedCleaning || 0)
        + (workload.tasks || 0);
}

export function getActiveWorkers(fieldWorkerArray = []) {
    return fieldWorkerArray.filter((worker) => worker.isDeleted !== true);
}

export default function SchedulerWorkerTagCloud({
    activeWorkerId,
    ariaLabel = "Workers",
    fieldWorkerArray = [],
    onChange,
    onOpenWorkerMap,
    showWorkerLocation = false,
    todayWorkerIds = EMPTY_WORKER_IDS,
    workerWorkloadCounts,
}) {
    const workers = getActiveWorkers(fieldWorkerArray);

    if (workers.length === 0) {
        return <p className="scheduler-worker-tag-cloud-empty">No workers available</p>;
    }

    return (
        <div className="scheduler-worker-tag-cloud" role="listbox" aria-label={ariaLabel}>
            {workers.map((worker) => {
                const isSelected = String(activeWorkerId) === String(worker.id);
                const hasGpsStatus = showWorkerLocation
                    && todayWorkerIds.has(String(worker.id))
                    && worker.locationTracking?.app_reported === true;

                return (
                    <div key={worker.id} className={`scheduler-worker-tag-item${isSelected ? ' is-selected' : ''}`}>
                        <button
                            type="button"
                            role="option"
                            aria-selected={isSelected}
                            className={`scheduler-worker-tag${isSelected ? " is-selected" : ""}${hasGpsStatus ? " has-gps" : ""}`}
                            onClick={() => onChange(String(worker.id))}
                        >
                            <span className="scheduler-worker-name">
                                <span>{worker.name}</span>
                            </span>
                            <span className="scheduler-worker-tag-count">
                                {getWorkloadCount(workerWorkloadCounts, worker.id)}
                            </span>
                        </button>
                        {hasGpsStatus ? <WorkerLocationStatusIcon
                            tracking={worker.locationTracking}
                            workerName={worker.name}
                            onOpenMap={onOpenWorkerMap && worker.userId != null ? () => onOpenWorkerMap(worker.userId) : undefined}
                        /> : null}
                    </div>
                );
            })}
        </div>
    );
}
